export const STORE_HISTORY = 'historyUI';
export type STORE_HISTORY = typeof STORE_HISTORY;

export const STORE_ADMINISTRATION_HISTORY = 'administrationHistory';
export type STORE_ADMINISTRATION_HISTORY = typeof STORE_ADMINISTRATION_HISTORY;
